package com.trevorwiebe.timesheet.loads.domain.model

import kotlinx.datetime.LocalDate

enum class StopType { PICKUP, DROP }

data class LoadStop(
    val locationId: String,
    val type: StopType,
)

data class LoadAttachment(
    val name: String,
    val url: String,
    val uploadedById: String = "",
)

data class Load(
    val id: String,
    val customerId: String,
    val loadNumber: String = "",
    val po: String = "",
    val orderNumber: String = "",
    val commodity: String = "",
    val customerRequirements: String = "",
    val pickupDate: LocalDate,
    val originalDate: LocalDate,
    val scheduledDate: LocalDate? = null,
    val stops: List<LoadStop>,
    val employeeId: String = "",
    val carrierId: String = "",
    val dispatchConfirmed: Boolean = false,
    val setUp: Boolean = false,
    val ready: Boolean = false,
    val rate: LoadRateInfo? = null,
    val attachments: List<LoadAttachment> = emptyList(),
    // Set by hand only; when blank the truck is matched from the driver's mileage log.
    val truckId: String = "",
)

val Load.isScheduled: Boolean get() = scheduledDate != null

val Load.hasCarrier: Boolean get() = carrierId.isNotEmpty()

fun Load.isCompleted(today: LocalDate): Boolean =
    scheduledDate != null && scheduledDate < today

val Load.pickups: List<LoadStop>
    get() = stops.filter { it.type == StopType.PICKUP }

val Load.drops: List<LoadStop>
    get() = stops.filter { it.type == StopType.DROP }
